var _path, _circle, _path2, _circle2, _circle3, _circle4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrecipitationChange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    fit: "",
    preserveAspectRatio: "xMidYMid meet",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m13.141 6 3.04 3.245V7.968c0-.474.506-.71 1.52-.71.944 0 1.463.206 1.555.618l.013.092v4.344l.997.935c.49.362.734.85.734 1.465 0 .553-.126.937-.378 1.153l-.09.066H19.27l.001 2.779A9.37 9.37 0 0 0 22 17.564v2.817C20.131 21.461 18.057 22 15.777 22c-3.42 0-4.791-2.182-8.628-2.182-2.559 0-4.275.35-5.149 1.052v-2.817C2.913 17.35 4.608 17 7.083 17c.242 0 .473.009.695.026l-.003-1.095h-1.01c-.407 0-.765-.428-.765-1.22 0-.435.115-.783.346-1.042l.106-.106L13.14 6ZM15 16.5h-2a1 1 0 0 0-.993.883L12 17.5v.804c1.056.431 2.189.804 3.777.804l.223-.004V17.5a1 1 0 0 0-1-1Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 7,
    stroke: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 12h1v3h-1v-3Zm-.915 3.38-1.06-1.06-.705.705 1.06 1.06.705-.705ZM15 17h-3v1h3v-1Zm5.68-1.975-.705-.705-1.06 1.06.705.705 1.06-1.06ZM20 18v-1h3v1h-3Zm-2.5-2c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5Zm2.475 4.68-1.06-1.06.705-.705 1.06 1.06-.705.705Zm-5.655-.705.705.705 1.06-1.06-.705-.705-1.06 1.06ZM18 23h-1v-3h1v3Z",
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 4.5,
    r: 1.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 6.5,
    r: 1.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 10.5,
    r: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrecipitationChange);
export default __webpack_public_path__ + "static/media/precipitation_change.63af32945e851392079e782b7ed43940.svg";
export { ForwardRef as ReactComponent };